<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_insurance") }}</h5>
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="Insurance.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{ $t("message.contracts.signed_message_" + Insurance.SignatureType) }}
        {{ Insurance.SignDate }}<br />
        {{ Insurance.SignatureName }}
      </span>
    </div>
    <div class="row">
      <div class="col-md-8">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.policy_holder_name"
            :placeholder="$t('message.contracts.insurance_policy_holder_name')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_policy_holder_name"
          />
          <label
            for="insurance_policy_holder_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_policy_holder_name") }}</label
          >
        </span>
      </div>
      <div class="col-md-4">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.insurance_is_public_person") }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="Insurance.is_public_person"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.represented_by"
            :placeholder="$t('message.contracts.insurance_represented_by')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_represented_by"
          />
          <label
            for="insurance_represented_by"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_represented_by") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.legal_address"
            :placeholder="$t('message.contracts.insurance_legal_address')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_legal_address"
          />
          <label
            for="insurance_legal_address"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_legal_address") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.actual_address"
            :placeholder="$t('message.contracts.insurance_actual_address')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_actual_address"
          />
          <label
            for="insurance_actual_address"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_actual_address") }}</label
          >
        </span>
      </div>
      <div class="col-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.insured_details"
            :placeholder="$t('message.contracts.insurance_insured_details')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_insured_details"
          />
          <label
            for="insurance_insured_details"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_insured_details") }}</label
          >
        </span>
      </div>
      <div class="col-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.insured_activity"
            :placeholder="$t('message.contracts.insurance_insured_activity')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_insured_activity"
          />
          <label
            for="insurance_insured_activity"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_insured_activity") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.beneficiary"
            :placeholder="$t('message.contracts.insurance_beneficiary')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_beneficiary"
          />
          <label
            for="insurance_beneficiary"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_beneficiary") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.beneficiary_details"
            :placeholder="$t('message.contracts.insurance_beneficiary_details')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_beneficiary_details"
          />
          <label
            for="insurance_beneficiary_details"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_beneficiary_details") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.shipping_name"
            :placeholder="$t('message.contracts.insurance_shipping_name')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_shipping_name"
          />
          <label
            for="insurance_shipping_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_shipping_name") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.package_info"
            :placeholder="$t('message.contracts.insurance_package_info')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_package_info"
          />
          <label
            for="insurance_package_info"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_package_info") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_cargo_cost"
            :class="[
              'form-label-group-label shorter',
              Insurance.cargo_cost != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_cargo_cost") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_cargo_cost"
            v-model="Insurance.cargo_cost"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_cargo_cost')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_package_count"
            :class="[
              'form-label-group-label shorter',
              Insurance.package_count != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_package_count") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_package_count"
            v-model="Insurance.package_count"
            :options="cleaveInt"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_package_count')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_total_cost"
            :class="[
              'form-label-group-label shorter',
              Insurance.total_cost != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_total_cost") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_total_cost"
            v-model="Insurance.total_cost"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_total_cost')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group shorter']">
          <datepicker
            :disabled="is_field_readonly"
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="Insurance.release_date = ' '"
            @blur="
              Insurance.release_date == ' '
                ? (Insurance.release_date = '')
                : (Insurance.release_date = Insurance.release_date)
            "
            inputClass="form-control"
            v-model="Insurance.release_date"
            :placeholder="$t('message.contracts.insurance_release_date')"
            :inputAttr="{ id: 'insurance_release_date' }"
          />
          <label
            for="insurance_release_date"
            class="form-label-group-label shorter"
            :class="
              Insurance.release_date != '' && Insurance.release_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.insurance_release_date") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.insurance_containerization") }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="Insurance.containerization"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.cargo_placing"
            :placeholder="$t('message.contracts.insurance_cargo_placing')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_cargo_placing"
          />
          <label
            for="insurance_cargo_placing"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_cargo_placing") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.route"
            :placeholder="$t('message.contracts.insurance_route')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_route"
          />
          <label for="insurance_route" class="form-label-group-label shorter">{{
            $t("message.contracts.insurance_route")
          }}</label>
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.security_measures"
            :placeholder="$t('message.contracts.insurance_security_measures')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_security_measures"
          />
          <label
            for="insurance_security_measures"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_security_measures") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.transport_means"
            :placeholder="$t('message.contracts.insurance_transport_means')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_transport_means"
          />
          <label
            for="insurance_transport_means"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_transport_means") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.transfer_points"
            :placeholder="$t('message.contracts.insurance_transfer_points')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_transfer_points"
          />
          <label
            for="insurance_transfer_points"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_transfer_points") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.shipping_details"
            :placeholder="$t('message.contracts.insurance_shipping_details')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_shipping_details"
          />
          <label
            for="insurance_shipping_details"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_shipping_details") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <h5>{{ $t("message.contracts.insurance_risk") }}</h5>
      </div>
      <div class="col-md-4">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.insurance_risk_a") }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="Insurance.risk_a"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.insurance_risk_b1") }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="Insurance.risk_b1"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.insurance_risk_b2") }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="Insurance.risk_b2"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            :readonly="is_field_readonly"
            class="form-control"
            v-model="Insurance.additional_conditions"
            :placeholder="
              $t('message.contracts.insurance_additional_conditions')
            "
            autocomplete="off"
            style="cursor: auto"
            id="insurance_additional_conditions"
          />
          <label
            for="insurance_additional_conditions"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.insurance_additional_conditions")
            }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <h5>{{ $t("message.contracts.insurance_max_value") }}</h5>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_a"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_a != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_a") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_a"
            v-model="Insurance.max_value_a"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_a')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_b"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_b != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_b") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_b"
            v-model="Insurance.max_value_b"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_b')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_c"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_c != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_c") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_c"
            v-model="Insurance.max_value_c"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_c')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_d"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_d != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_d") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_d"
            v-model="Insurance.max_value_d"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_d')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_e"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_e != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_e") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_e"
            v-model="Insurance.max_value_e"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_e')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_max_value_f"
            :class="[
              'form-label-group-label shorter',
              Insurance.max_value_f != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.insurance_max_value_f") }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_max_value_f"
            v-model="Insurance.max_value_f"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.insurance_max_value_f')"
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{
              $t("message.contracts.insurance_insured_transport")
            }}</span
            ><br /><br />
            <input
              :disabled="is_field_readonly"
              type="checkbox"
              v-model="Insurance.insured_transport"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="insurance_insured_transport_amount"
            :class="[
              'form-label-group-label shorter',
              Insurance.insured_transport_amount != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.insurance_insured_transport_amount")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="insurance_insured_transport_amount"
            v-model="Insurance.insured_transport_amount"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="
              $t('message.contracts.insurance_insured_transport_amount')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="Insurance.franchise"
            :placeholder="$t('message.contracts.insurance_franchise')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_franchise"
          />
          <label
            for="insurance_franchise"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_franchise") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group shorter']">
          <datepicker
            :disabled="is_field_readonly"
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="Insurance.shipment_date = ' '"
            @blur="
              Insurance.shipment_date == ' '
                ? (Insurance.shipment_date = '')
                : (Insurance.shipment_date = Insurance.shipment_date)
            "
            inputClass="form-control"
            v-model="Insurance.shipment_date"
            :placeholder="$t('message.contracts.insurance_shipment_date')"
            :inputAttr="{ id: 'insurance_shipment_date' }"
          />
          <label
            for="insurance_shipment_date"
            class="form-label-group-label shorter"
            :class="
              Insurance.shipment_date != '' && Insurance.shipment_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.insurance_shipment_date") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="Insurance.shipment_duration"
            :placeholder="$t('message.contracts.insurance_shipment_duration')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_shipment_duration"
          />
          <label
            for="insurance_shipment_duration"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_shipment_duration") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="Insurance.insurance_stats"
            :placeholder="$t('message.contracts.insurance_insurance_stats')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_insurance_stats"
          />
          <label
            for="insurance_insurance_stats"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_insurance_stats") }}</label
          >
        </span>
        <small>
          <i>
            {{ $t("message.contracts.insurance_insurance_stats_desc") }}
          </i>
        </small>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="Insurance.relevant_info"
            :placeholder="$t('message.contracts.insurance_relevant_info')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_relevant_info"
          />
          <label
            for="insurance_relevant_info"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.insurance_relevant_info") }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="Insurance.other"
            :placeholder="$t('message.contracts.insurance_other')"
            autocomplete="off"
            style="cursor: auto"
            id="insurance_other"
          />
          <label for="insurance_other" class="form-label-group-label shorter">{{
            $t("message.contracts.insurance_other")
          }}</label>
        </span>
      </div>
      <div class="buttons2 ml-3" v-if="is_edit">
        <button
          class="btn btn-success float-left"
          @click="saveDocument()"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}
        </button>
      </div>
    </div>

    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
      v-if="!is_field_readonly && !is_edit"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!has_insurance_certificate"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!is_new"
          @click="submit_and_sign_dialog()"
          :disabled="buttons_loading"
          >{{ $t("message.contracts.submit_and_sign_button") }}</a
        >
      </div>
      <!--<button v-if="!has_insurance_certificate" class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button> -->
      <button
        v-if="!is_new && !has_insurance_certificate && !insurance_request_sent"
        class="btn btn-success btn-sm float-left mr-2"
        v-b-modal.modal-send_request
        :disabled="buttons_loading"
      >
        {{ $t("message.contracts.send_insurance_request") }}
      </button>
      <a
        v-if="!is_new && has_insurance_certificate"
        :href="insurance_request.certificate"
        rel="noopener noreferrer"
        target="_blank"
        class="btn btn-success btn-sm mr-2 float-left"
        :disabled="buttons_loading"
        >{{ $t("message.contracts.download_insurance_certificate") }}</a
      >

      <!-- <button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>
    <b-modal
      id="modal-select-ecp-type-insurance"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="modal-send_request"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.send_insurance_request')"
    >
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_statute">{{
            $t("message.account.statute")
          }}</label>
          <input
            type="file"
            id="insurance_statute"
            class="form-control1"
            @change="fileHandleInsurance($event, 'statute')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_registration_certificate">{{
            $t("message.account.registration_certificate")
          }}</label>
          <input
            type="file"
            id="insurance_registration_certificate"
            class="form-control1"
            @change="fileHandleInsurance($event, 'registration_certificate')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_signature_right_certificate">{{
            $t("message.account.signature_right_certificate")
          }}</label>
          <input
            type="file"
            id="insurance_signature_right_certificate"
            class="form-control1"
            @change="fileHandleInsurance($event, 'signature_right_certificate')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_ceo_passport">{{
            $t("message.account.ceo_passport")
          }}</label>
          <input
            type="file"
            id="insurance_ceo_passport"
            class="form-control1"
            @change="fileHandleInsurance($event, 'ceo_passport')"
          />
        </div>
      </div>
      <button class="btn btn-success" @click="saveInsuranceRequest">
        {{ $t("message.send") }}
      </button>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: [
    "goods",
    "contract_details",
    "document_id",
    "is_new",
    "document",
    "readonly",
    "is_edit",
    "files",
  ],
  name: "form-insurance",
  data() {
    return {
      buttons_loading: false,
      currencies: [],
      loading: false,
      show_code_sign_type: false,
      sign_with_code_code: "",

      doc_id: "",

      Insurance: {
        // doc_id:"1",
        policy_holder_name: "",
        represented_by: "",
        legal_address: "",
        actual_address: "",
        is_public_person: "",
        insured_details: "",
        insured_activity: "",
        beneficiary: "",
        beneficiary_details: "",
        shipping_name: "",
        package_info: "",
        cargo_cost: "",
        package_count: "",
        total_cost: "",
        release_date: "",
        containerization: false,
        cargo_placing: "",
        route: "",
        security_measures: "",
        transport_means: "",
        transfer_points: "",
        shipping_details: "",
        risk_a: false,
        risk_b1: false,
        risk_b2: false,
        additional_conditions: "",
        max_value_a: "",
        max_value_b: "",
        max_value_c: "",
        max_value_d: "",
        max_value_e: "",
        max_value_f: "",
        insured_transport: false,
        insured_transport_amount: "",
        franchise: "",
        shipment_date: "",
        shipment_duration: "",
        insurance_stats: "",
        relevant_info: "",
        other: "",
        SignDate: "",
        SignatureType: "",
        SignatureName: "",
        IsSigned: false,
      },

      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },

      cleaveInt: {
        numeral: true,
        numeralDecimalMark: "",
        delimiter: "",
      },
      current_insurance_request: {
        statute: null,
        registration_certificate: null,
        signature_right_certificate: null,
        ceo_passport: null,
      },
      insurance_request: {},
      has_insurance_certificate: false,
      insurance_request_sent: false,
    };
  },
  methods: {
    /**
     * checks if current document has insurance request
     */
    load_insurance_requests() {
      axios
        .get(window.base + "/account/load_my_insurance_requests")
        .then((response) => {
          for (var i in response.data) {
            var request = response.data[i];
            if (request.document_id == this.doc_id) {
              this.insurance_request_sent = true;
              this.insurance_request = request;
              if (
                typeof request.certificate === "string" &&
                request.certificate != ""
              )
                this.has_insurance_certificate = true;
              break;
            }
          }
          // response.data.forEach(request => {
          // 	if(request.document_id == this.document_id){
          // 		this.insurance_request = request
          // 		if(typeof request.certificate === 'string' && request.certificate!='')
          // 			this.has_insurance_certificate = true
          // 	}
          // })
        });
    },
    /**
     * SAVES/updates insurance requests
     */
    saveInsuranceRequest() {
      let fd = new FormData();
      fd.append("contract_id", this.contract_details.attis_contract_id);
      fd.append("org_name", this.Insurance.policy_holder_name);
      fd.append("ceo_name", this.Insurance.represented_by);
      fd.append("document_id", this.document_id);
      fd.append("statute", this.current_insurance_request.statute);
      fd.append(
        "registration_certificate",
        this.current_insurance_request.registration_certificate,
      );
      fd.append(
        "signature_right_certificate",
        this.current_insurance_request.signature_right_certificate,
      );
      fd.append("ceo_passport", this.current_insurance_request.ceo_passport);
      fd.append("insurance_type", 6);
      fd.append("amount", this.Insurance.total_cost);

      // account/create_insurance_request
      axios
        .post(window.base + "/account/create_insurance_request", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.status == "ok") {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.success"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-send_request");
            this.load_insurance_requests();
          } else {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-send_request");
            this.load_insurance_requests();
          }
        })
        .catch((e) => {
          this.add_insurance_request = false;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.no_success"),
            timeout: 5000,
          }).show();
          this.$bvModal.hide("modal-send_request");
          this.load_insurance_requests();
        });
    },
    /**
     * handles file select event
     */
    fileHandleInsurance(event, type) {
      this.current_insurance_request[type] = event.target.files[0];
    },
    /**
     * Loads data from library using parameters type, query and qty,
     * sets results as an array to data-property with name of plural form of type
     */
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    amount(goods) {
      var amount = 0;
      goods.forEach((item) => {
        amount += item.attis_cg_price * item.attis_cg_quantity;
      });
      return this.addThousandsSeparator(amount.toString(), ",");
    },
    productNames(goods) {
      var names = "";
      for (var i = 0; i < goods.length; i++) {
        if (
          typeof goods[i + 1] !== "undefined" &&
          typeof goods[i].attis_cg_good_name !== "undefined"
        )
          names = names + goods[i].attis_cg_good_name + ", ";
        else if (typeof goods[i].attis_cg_good_name !== "undefined")
          names = names + goods[i].attis_cg_good_name;
      }
      return names;
    },
    placesCount(packing_lists) {
      var count = 0;
      packing_lists.forEach((packing) => {
        packing.places.forEach((place) => {
          if (
            typeof place !== "undefined" &&
            typeof place.packging_placescount !== "undefined"
          )
            count += place.packging_placescount;
        });
      });
      return count;
    },
    representationName(person) {
      return (
        person.given_name +
        " " +
        person.middle_name +
        " " +
        person.last_name +
        ", " +
        person.position
      );
    },
    representationDetails(bank, company) {
      var curr =
        this.currencies[
          this.currencies.findIndex(
            (itm) => itm.value == bank.subj_bank_acc_curr.trim(),
          )
        ];
      return (
        bank.subj_bank +
        " " +
        bank.subj_bank_acc_number +
        " " +
        curr.display_text +
        " " +
        company.company_email
      );
    },
    formatRoute(cmr) {
      return (
        cmr.City.trim() +
        " " +
        cmr.StreetHouse.trim() +
        " - " +
        cmr.DeliveryPlace.trim()
      );
    },
    legalAddress(addres, residency) {
      let sub_address = { ...addres };
      delete sub_address.subj_post_addr_type;
      delete sub_address.post_addr_country;
      return (
        residency.display_text +
        " " +
        Object.values(sub_address).join(" ").trim()
      ); //addres.post_addr_city + " " + addres.post_addr_district + " " + addres.post_addr_streethouse + " " + addres.post_addr_house;
    },
    addThousandsSeparator(n, thousandsSeparatorSymbol) {
      return new Intl.NumberFormat(this.locale).format(n);
    },
    /**
     * Fetches list of measures from library
     */
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    /**
     * Fetches list of currencies from library
     */
    fetchCurrencies(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base +
              "/document/LoadInsuranceXML?doc_id=" +
              this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-insurance");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-insurance");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Displays a dialog to select which method of electronic signature fits user the best.
     */
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-insurance");
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base + "/document/LoadInsuranceXML?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      let name = response.data.cert_name;
                      var fd = new FormData();
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature_name", name);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-insurance");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-insurance");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    load() {
      axios
        .get(
          window.base + "/Document/LoadInsurance/?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.$emit("file", response.data.files);
          this.Insurance = response.data;
          this.doc_id = response.data.doc_id;
        });
    },
    /**
     * checks field value and if it should be int/decimal but is empty set's 0
     */
    check_field_value(field, value) {
      let list_of_decimal_fields = [
        "cargo_cost",
        "total_cost",
        "max_value_a",
        "max_value_b",
        "max_value_c",
        "max_value_d",
        "max_value_e",
        "max_value_f",
        "insured_transport_amount",
      ];
      let list_of_int_fields = ["ID", "package_count"];

      let list_of_bool_fields = [
        "is_public_person",
        "containerization",
        "risk_a",
        "risk_b1",
        "risk_b2",
        "insured_transport",
      ];

      if (field == "ID") return value;

      if (_.includes(list_of_decimal_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0")
          return 0.0; //zero double
        else return parseFloat(value);
      } else if (_.includes(list_of_int_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0") {
          return 0; //zero int
        } else {
          return parseInt(value);
        }
      } else if (_.includes(list_of_bool_fields, field)) {
        if (value === true || value == 1) return 1;
        else return 0;
      } else {
        if (_.isEmpty(value)) return "";
        else return value;
      }
    },
    check_json_before_sending(json) {
      let tmp = {};
      for (let i in json) {
        if (_.isArray(json[i])) {
          if (json[i].length == 0) tmp[i] = [];
          json[i].forEach((array_item, j) => {
            tmp[i] = [];
            if (typeof array_item === "object") {
              tmp[i].push(this.check_json_before_sending(array_item));
            } else {
              tmp[i].push(this.check_field_value(j, array_item));
            }
          });
        } else if (typeof json[i] === "object") {
          tmp[i] = this.check_json_before_sending(json[i]);
        } else {
          tmp[i] = this.check_field_value(i, json[i]);
        }
      }
      return tmp;
    },
    saveDocument() {
      var data = {
        document: this.document,
      };
      this.$root.$emit("show-loading");
      this.buttons_loading = true;
      var tmp = this.Insurance;
      tmp.files = this.files;
      var t1 = this.$t("message.error");
      axios
        .post(
          window.base +
            (this.is_new === true
              ? "/Document/createInsurance" +
                "?attis_contract_id=" +
                this.$route.params.id +
                "&contract_id=" +
                this.$route.params.id
              : "/Document/updateInsurance" + "?doc_id=" + this.document_id),
          this.check_json_before_sending(tmp),
        )
        .then((response) => {
          console.log(response.data);
          if (response.data == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.insurance-created"),
              timeout: 5000,
            }).show();
            this.$root.$emit("loadDocuments", { category: "all" });
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
            if (this.is_edit) {
              this.$root.$emit("insurance-saved");
            }
          } else {
            console.info("else case");
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.insurance-not-created") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
            if (window.dev_mode) {
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            }
          }
        })
        .catch((e) => {
          console.log(e);
          new Noty({
            theme: "light",
            type: "error",
            text: t1,
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
  },
  mounted() {
    // this.fetchContragents('')
    // this.fetchCountries('')
    this.fetchCurrencies("");
    // this.fetchMeasures('')
    console.log("contract_details");
    console.log(this.contract_details);
    if (this.document_id != "new") {
      this.load();
      this.load_insurance_requests();
    } else {
      axios
        .get(
          window.base +
            "/document/InsuranceInitialData?attis_contract_id=" +
            this.$route.params.id,
        )
        .then((response) => {
          var initialData = response.data;
          console.log("initial data");
          console.log(initialData);

          this.Insurance.total_cost = this.amount(initialData.products);
          this.Insurance.shipping_name = this.productNames(
            initialData.products,
          );
          this.Insurance.package_count = this.placesCount(
            initialData.packing_lists,
          );
          this.Insurance.policy_holder_name =
            initialData.contract_owner.organizations.org_name;
          if (typeof initialData.contract_owner.persons !== "undefined")
            this.Insurance.represented_by = this.representationName(
              initialData.contract_owner.persons,
            );
          if (typeof initialData.contract_owner.addresses[0] !== "undefined")
            this.Insurance.legal_address = this.legalAddress(
              initialData.contract_owner.addresses[0],
              initialData.contract_owner.org_residency,
            );
          if (typeof initialData.contract_owner.addresses[1] !== "undefined")
            this.Insurance.actual_address = this.legalAddress(
              initialData.contract_owner.addresses[1],
              initialData.contract_owner.org_residency,
            );
          if (typeof initialData.contract_owner.banks[0] !== "undefined") {
            this.Insurance.insured_details = this.representationDetails(
              initialData.contract_owner.banks[0],
              initialData.contract_owner.organizations,
            );
            this.Insurance.beneficiary_details = this.representationDetails(
              initialData.contract_owner.banks[0],
              initialData.contract_owner.organizations,
            );
          }

          if (
            typeof initialData.contract_owner.organizations.org_type !==
            "undefined"
          ) {
            axios
              .get(
                window.base +
                  "/library/org_type?code=" +
                  initialData.contract_owner.organizations.org_type +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                this.Insurance.insured_activity = resp.data[0].display_text;
              });
          }

          this.Insurance.beneficiary =
            initialData.contract_owner.organizations.org_name;

          this.Insurance.route = this.formatRoute(initialData.cmr);
        });
    }
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.Insurance.IsSigned || this.readonly) return true;
      return false;
    },
  },
  watch: {},
  validations: {},
};
</script>
<style>
#rwb_contract_date__outer_ {
  padding: 0 !important;
  height: 36px !important;
}
.b-form-timepicker label {
  background-image: none !important;
  align-self: center;
  padding-top: 6px;
  border: 0 !important;
}
.b-form-timepicker .btn {
  background: #fff !important;
  color: #3c4858;
}
</style>
